export const AppConfig = {
    ApiURL: (process.env.REACT_APP_API_HOST ?? 'https://atacapi.azurewebsites.net/api')
}